import { render, staticRenderFns } from "./PayCtrl.vue?vue&type=template&id=58c34336&"
import script from "./PayCtrl.vue?vue&type=script&lang=js&"
export * from "./PayCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports